
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexM0XmuIOUouLt6vI6GNdDzXXCF6PSXc10ppzAZDykFl8Meta } from "/app/pages/app/index.vue?macro=true";
import { default as profilesF5kcAXAk1TFrmY2ZleVGeZcaiwnLTeNZ8fX0UhJtBDYMeta } from "/app/pages/app/profiles.vue?macro=true";
import { default as _91id_93ILr_Ta_e7VONf7pOSH9pqv3p1JJz8rTmpP88ihIcUPMMeta } from "/app/pages/app/scores/[id].vue?macro=true";
import { default as _91id_93kmGZqfU7gr7EFORdEWXljTv6s3B9gHKvKLY6wwN691wMeta } from "/app/pages/app/upload/[id].vue?macro=true";
import { default as _91id_93gE5qVYDFHNJ7AFicmw87OtWnBdQ60HVtekaA_45003OnUMeta } from "/app/pages/app/lottery/[id].vue?macro=true";
import { default as _91id_933HK1NkBRA8c7VwZ7yOv3qnH9xJhOv_nws7nhlxUBHc8Meta } from "/app/pages/app/exchange/[id].vue?macro=true";
import { default as _91id_93PNmeS1KAvg5Zf43P92S1eXAOSs35cH1KhuQSbYUipDwMeta } from "/app/pages/app/documents/[id].vue?macro=true";
import { default as indexjwuMRQX_I0_45ezh4GVqxz_4nTegnDRNbQRHziIkhgqWcMeta } from "/app/pages/app/messages/index.vue?macro=true";
import { default as change_45passwordiSCuQ55wzhTWLT9Yhh_4513h6XUZo60KMujhGkN5EKyoUMeta } from "/app/pages/app/change-password.vue?macro=true";
import { default as _91id_93o0kW29sUOQoj9fAeI8r6P4jPOxjif_45RBpjYxtPc6QxkMeta } from "/app/pages/app/messages/detail/[id].vue?macro=true";
import { default as appoARvJ9pTIAlSwGNu9CDvfiuUETdLPDqEIX3DFwG66D0Meta } from "/app/pages/app.vue?macro=true";
import { default as qnaI5Tzf6uDxFV4wbNHXL8FUWZrEX73fZeV2wA6p6aLe_wMeta } from "/app/pages/qna.vue?macro=true";
import { default as siteQ_Zphi5xgIyG3Lpm28fYoXpLy4_SlhdRKnQVjX6gpCUMeta } from "/app/pages/admin/site.vue?macro=true";
import { default as _91id_93lNjooASpF2H0u6aDBzCkrAUXdK3oujtLrYPj2fAMCUwMeta } from "/app/pages/admin/events/[id].vue?macro=true";
import { default as indextzd0wN1oAsADI72AaOG0qX6dzw57A0p7zQP4CLWx98YMeta } from "/app/pages/admin/events/index.vue?macro=true";
import { default as _91id_93IcArDudQUSGuTcKHgVKwAVQykZzXiwa_45P_MLEU6z1ykMeta } from "/app/pages/admin/articles/[id].vue?macro=true";
import { default as indexiNC6RctP4nDeQkigSJawUpNgpeu_45YA0MlzesS3bjZyoMeta } from "/app/pages/admin/articles/index.vue?macro=true";
import { default as indexvhARdWHtzAx7tGLFCKIO9RrIx59QSOqRvpcxWHyDF_450Meta } from "/app/pages/admin/messages/index.vue?macro=true";
import { default as createpdJ7nRs9fjCbj5if476Ok3c_TYKqvkm9sD2j2q4YuEcMeta } from "/app/pages/admin/messages/create.vue?macro=true";
import { default as indexl80tXM_tRQ1rMbTDIWoMMQ4OVR3kZ_nzIEGcKtG8sSUMeta } from "/app/pages/admin/broadcasts/index.vue?macro=true";
import { default as _91id_93rAaMFal_45m8PQuwCA8JTg0fJodWs8q6MsAGKhSCcLgnEMeta } from "/app/pages/admin/qna-articles/[id].vue?macro=true";
import { default as indexxPf6XDPhpvbzney_p3akpcoreAGD5z_45HY5yTjZmgyt8Meta } from "/app/pages/admin/qna-articles/index.vue?macro=true";
import { default as _91id_93A7iSNmIP7XwQyxB6t4icmYIy_45QN1eE0dJq0kE6OQ_45pIMeta } from "/app/pages/admin/messages/detail/[id].vue?macro=true";
import { default as _91id_93T1hj8SX4nTNP12dce4HFvSSX_RagTSjY2UDbXb0gs_QMeta } from "/app/pages/admin/signup/[eventId]/[id].vue?macro=true";
import { default as _91id_9301I1XWUk6jLVro9T7knIdrvLhjaJwogS1LJ7C5X1KngMeta } from "/app/pages/admin/upload/[eventId]/[id].vue?macro=true";
import { default as index5pLv34gg6gwTUjlzoq1h0k6VBNY2X0Odq8PTTfJeHuYMeta } from "/app/pages/admin/signup/[eventId]/index.vue?macro=true";
import { default as indexHdzQqAsFYGM16_45Jflac_450xrr2T_basnXwti4l3nQWEcMeta } from "/app/pages/admin/upload/[eventId]/index.vue?macro=true";
import { default as _91id_93fT1bxnsipyz0OPcJx7e1tyv1NLPKqCjS56f7phRg1mcMeta } from "/app/pages/admin/exchange/[eventId]/[id].vue?macro=true";
import { default as indexO_4qEOqkaGq6Lqmq3xlzzzra1VFsHBXCkciHW8KETLcMeta } from "/app/pages/admin/lottery/[eventId]/index.vue?macro=true";
import { default as _91id_93atys54RloeMu_45K5_e2FSMEXWmwuRZVfzDZWNOB8EHiEMeta } from "/app/pages/admin/profiles/[eventId]/[id].vue?macro=true";
import { default as configslRF7e48XQc3R6xKmbfPzwK5Ieh3G85UUQFaJDZ8LhUMeta } from "/app/pages/admin/upload/[eventId]/config.vue?macro=true";
import { default as index1lA2F9MBVmQxVm3oras_45bgApRHnLi41bpUGlEvd_cFkMeta } from "/app/pages/admin/exchange/[eventId]/index.vue?macro=true";
import { default as configDCHBjMwklMzH1v_45YUcEeScGUj9Q_2AO50PaPrwzAyhoMeta } from "/app/pages/admin/lottery/[eventId]/config.vue?macro=true";
import { default as indexOF9aH75ExOYiwArQUgkjSrQmyqNlRKyNACIAnpjLUB0Meta } from "/app/pages/admin/profiles/[eventId]/index.vue?macro=true";
import { default as indexZrQk_45C746izIP3LFxJTtEL53LGYKNlSnk4EaqX6wZhMMeta } from "/app/pages/admin/documents/[eventId]/index.vue?macro=true";
import { default as configi2CCPQFeNfJfjf8nFhhcHkMijaa2dO3ptMR9_I_45ehuwMeta } from "/app/pages/admin/exchange/[eventId]/config.vue?macro=true";
import { default as configmI2OIejBkDpiHJWRJQSnpitYnhC_TplgOrK_0PSQHkAMeta } from "/app/pages/admin/documents/[eventId]/config.vue?macro=true";
import { default as adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta } from "/app/pages/admin.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as signinawKlupfeildDdXrIM2LPmI5jOdsD7WNv6lb6o6QgkAEMeta } from "/app/pages/signin.vue?macro=true";
import { default as signupXDZ9vem3RhITR7dUmFJxupvJgksTCjysSig_ObPaBwEMeta } from "/app/pages/signup.vue?macro=true";
import { default as adminGhU2pc5thHW6i4xmAPP9gCVrtHQCGIskjX_BhylG01oMeta } from "/app/pages/auth/admin.vue?macro=true";
import { default as storyzDp8DPu94imQYmoM4IYCTGT_45c5qMARu3dBZ39fewH3UMeta } from "/app/pages/timer/story.js?macro=true";
import { default as indexuKaPUX4GCf_T8dWathdbv84rXNbewUhIxPlJ_45SGRtmkMeta } from "/app/pages/timer/index.vue?macro=true";
import { default as _91id_93pMMtwfxV9GfXX17XNJ2rSL2iLj4UtR_z45UbmTB_45LXMMeta } from "/app/pages/articles/[id].vue?macro=true";
import { default as index9j3HrWpRPsPPlMB7_45YSFbtoOPNwVLFXfBC_vX1oMrfkMeta } from "/app/pages/articles/index.vue?macro=true";
import { default as story_46defaultZM8OoHYzrUi89t9K7e75z_JycY1aMZMfHGH5BWnhnFUMeta } from "/app/pages/timer/story.default.js?macro=true";
export default [
  {
    name: appoARvJ9pTIAlSwGNu9CDvfiuUETdLPDqEIX3DFwG66D0Meta?.name,
    path: "/app",
    component: () => import("/app/pages/app.vue"),
    children: [
  {
    name: "app",
    path: "",
    component: () => import("/app/pages/app/index.vue")
  },
  {
    name: "app-profiles",
    path: "profiles",
    component: () => import("/app/pages/app/profiles.vue")
  },
  {
    name: "app-scores-id",
    path: "scores/:id()",
    component: () => import("/app/pages/app/scores/[id].vue")
  },
  {
    name: "app-upload-id",
    path: "upload/:id()",
    component: () => import("/app/pages/app/upload/[id].vue")
  },
  {
    name: "app-lottery-id",
    path: "lottery/:id()",
    component: () => import("/app/pages/app/lottery/[id].vue")
  },
  {
    name: "app-exchange-id",
    path: "exchange/:id()",
    component: () => import("/app/pages/app/exchange/[id].vue")
  },
  {
    name: "app-documents-id",
    path: "documents/:id()",
    component: () => import("/app/pages/app/documents/[id].vue")
  },
  {
    name: "app-messages",
    path: "messages",
    component: () => import("/app/pages/app/messages/index.vue")
  },
  {
    name: "app-change-password",
    path: "change-password",
    component: () => import("/app/pages/app/change-password.vue")
  },
  {
    name: "app-messages-detail-id",
    path: "messages/detail/:id()",
    component: () => import("/app/pages/app/messages/detail/[id].vue")
  }
]
  },
  {
    name: "qna",
    path: "/qna",
    component: () => import("/app/pages/qna.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin-site",
    path: "site",
    component: () => import("/app/pages/admin/site.vue")
  },
  {
    name: "admin-events-id",
    path: "events/:id()",
    component: () => import("/app/pages/admin/events/[id].vue")
  },
  {
    name: "admin-events",
    path: "events",
    component: () => import("/app/pages/admin/events/index.vue")
  },
  {
    name: "admin-articles-id",
    path: "articles/:id()",
    component: () => import("/app/pages/admin/articles/[id].vue")
  },
  {
    name: "admin-articles",
    path: "articles",
    component: () => import("/app/pages/admin/articles/index.vue")
  },
  {
    name: "admin-messages",
    path: "messages",
    component: () => import("/app/pages/admin/messages/index.vue")
  },
  {
    name: "admin-messages-create",
    path: "messages/create",
    component: () => import("/app/pages/admin/messages/create.vue")
  },
  {
    name: "admin-broadcasts",
    path: "broadcasts",
    component: () => import("/app/pages/admin/broadcasts/index.vue")
  },
  {
    name: "admin-qna-articles-id",
    path: "qna-articles/:id()",
    component: () => import("/app/pages/admin/qna-articles/[id].vue")
  },
  {
    name: "admin-qna-articles",
    path: "qna-articles",
    component: () => import("/app/pages/admin/qna-articles/index.vue")
  },
  {
    name: "admin-messages-detail-id",
    path: "messages/detail/:id()",
    component: () => import("/app/pages/admin/messages/detail/[id].vue")
  },
  {
    name: "admin-signup-eventId-id",
    path: "signup/:eventId()/:id()",
    component: () => import("/app/pages/admin/signup/[eventId]/[id].vue")
  },
  {
    name: "admin-upload-eventId-id",
    path: "upload/:eventId()/:id()",
    component: () => import("/app/pages/admin/upload/[eventId]/[id].vue")
  },
  {
    name: "admin-signup-eventId",
    path: "signup/:eventId()",
    component: () => import("/app/pages/admin/signup/[eventId]/index.vue")
  },
  {
    name: "admin-upload-eventId",
    path: "upload/:eventId()",
    component: () => import("/app/pages/admin/upload/[eventId]/index.vue")
  },
  {
    name: "admin-exchange-eventId-id",
    path: "exchange/:eventId()/:id()",
    component: () => import("/app/pages/admin/exchange/[eventId]/[id].vue")
  },
  {
    name: "admin-lottery-eventId",
    path: "lottery/:eventId()",
    component: () => import("/app/pages/admin/lottery/[eventId]/index.vue")
  },
  {
    name: "admin-profiles-eventId-id",
    path: "profiles/:eventId()/:id()",
    component: () => import("/app/pages/admin/profiles/[eventId]/[id].vue")
  },
  {
    name: "admin-upload-eventId-config",
    path: "upload/:eventId()/config",
    component: () => import("/app/pages/admin/upload/[eventId]/config.vue")
  },
  {
    name: "admin-exchange-eventId",
    path: "exchange/:eventId()",
    component: () => import("/app/pages/admin/exchange/[eventId]/index.vue")
  },
  {
    name: "admin-lottery-eventId-config",
    path: "lottery/:eventId()/config",
    component: () => import("/app/pages/admin/lottery/[eventId]/config.vue")
  },
  {
    name: "admin-profiles-eventId",
    path: "profiles/:eventId()",
    component: () => import("/app/pages/admin/profiles/[eventId]/index.vue")
  },
  {
    name: "admin-documents-eventId",
    path: "documents/:eventId()",
    component: () => import("/app/pages/admin/documents/[eventId]/index.vue")
  },
  {
    name: "admin-exchange-eventId-config",
    path: "exchange/:eventId()/config",
    component: () => import("/app/pages/admin/exchange/[eventId]/config.vue")
  },
  {
    name: "admin-documents-eventId-config",
    path: "documents/:eventId()/config",
    component: () => import("/app/pages/admin/documents/[eventId]/config.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "signin",
    path: "/signin",
    component: () => import("/app/pages/signin.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/app/pages/signup.vue")
  },
  {
    name: "auth-admin",
    path: "/auth/admin",
    component: () => import("/app/pages/auth/admin.vue")
  },
  {
    name: "timer-story",
    path: "/timer/story",
    component: () => import("/app/pages/timer/story.js")
  },
  {
    name: "timer",
    path: "/timer",
    component: () => import("/app/pages/timer/index.vue")
  },
  {
    name: "articles-id",
    path: "/articles/:id()",
    component: () => import("/app/pages/articles/[id].vue")
  },
  {
    name: "articles",
    path: "/articles",
    component: () => import("/app/pages/articles/index.vue")
  },
  {
    name: "timer-story.default",
    path: "/timer/story.default",
    component: () => import("/app/pages/timer/story.default.js")
  }
]